import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import AccountSettingPageContent from '@shared/components/settings/user/AccountSettingsPageContent';
import { useTranslation } from 'react-i18next';

export default function AccountSettingsPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <>
            <PageHeader title={t('common:account.settings')} items={items} />
            <AccountSettingPageContent />
        </>
    );
}
